import { useQueries } from '@tanstack/react-query';
import apiRequest from '../../../services/apiWrapper';
import { EMAIL_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';
import { EmailNotificationResendType } from '../../../utils/enums/email-notification-resend-type.enum';

async function getEmailLastSent(type: EmailNotificationResendType) {
  const response = await apiRequest.get<string>(
    `${EMAIL_NOTIFICATION_URL}/${type}/last`
  );
  return response.data;
}

export function useGetEmailLastSent() {
  return useQueries({
    queries: [
      {
        queryKey: [
          'email-last-sent',
          EmailNotificationResendType.daysBeforeDueDate,
        ],
        queryFn: () =>
          getEmailLastSent(EmailNotificationResendType.daysBeforeDueDate),
      },
      {
        queryKey: [
          'email-last-sent',
          EmailNotificationResendType.daysAfterDueDate,
        ],
        queryFn: () =>
          getEmailLastSent(EmailNotificationResendType.daysAfterDueDate),
      },
      {
        queryKey: [
          'email-last-sent',
          EmailNotificationResendType.daysAfterGracePeriod,
        ],
        queryFn: () =>
          getEmailLastSent(EmailNotificationResendType.daysAfterGracePeriod),
      },
      {
        queryKey: [
          'email-last-sent',
          EmailNotificationResendType.firstFoodPaymentReminder,
        ],
        queryFn: () =>
          getEmailLastSent(
            EmailNotificationResendType.firstFoodPaymentReminder
          ),
      },
      {
        queryKey: [
          'email-last-sent',
          EmailNotificationResendType.secondFoodPaymentReminder,
        ],
        queryFn: () =>
          getEmailLastSent(
            EmailNotificationResendType.secondFoodPaymentReminder
          ),
      },
    ],
  });
}
